const SHEET_CSV_URL = 'https://docs.google.com/spreadsheets/d/1HzfJpcoopEiL2e9lNDgfXqxy3ykhV98s1IuxjyXBN2A/export?format=csv&gid=0';
const PHONE_NUMBER_COLUMN = 'phone number';
const LOCATION_ID_COLUMN = 'location id';
const SWAP_NUMBER_COLUMN = 'swap number';

let phoneNumbersPromise = null;

const normalizeHeader = (value) => String(value || '').trim().toLowerCase();

const parseCsv = (csv) => {
  const rows = [];
  let row = [];
  let value = '';
  let inQuotes = false;

  for (let i = 0; i < csv.length; i += 1) {
    const char = csv[i];
    const nextChar = csv[i + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        value += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      row.push(value);
      value = '';
    } else if ((char === '\n' || char === '\r') && !inQuotes) {
      if (char === '\r' && nextChar === '\n') {
        i += 1;
      }
      row.push(value);
      rows.push(row);
      row = [];
      value = '';
    } else {
      value += char;
    }
  }

  row.push(value);
  rows.push(row);

  return rows.filter((csvRow) => csvRow.some((cell) => String(cell || '').trim()));
};

const buildPhoneNumberMap = (csv) => {
  const rows = parseCsv(csv);
  const headers = rows[0] || [];
  const normalizedHeaders = headers.map(normalizeHeader);
  const locationIdIndex = normalizedHeaders.indexOf(LOCATION_ID_COLUMN);
  const phoneNumberIndex = normalizedHeaders.indexOf(PHONE_NUMBER_COLUMN);
  const swapNumberIndex = normalizedHeaders.indexOf(SWAP_NUMBER_COLUMN);

  if (phoneNumberIndex === -1) {
    // eslint-disable-next-line no-console
    console.warn('Beltone Michigan clinic phone sheet is missing the Phone Number column. Falling back to the default phone number.');
    return {};
  }

  if (locationIdIndex === -1) {
    // eslint-disable-next-line no-console
    console.warn('Beltone Michigan clinic phone sheet is missing the Location ID column. Falling back to the default phone number.');
    return {};
  }

  return rows.slice(1).reduce((phoneNumbers, csvRow) => {
    const clinicId = String(csvRow[locationIdIndex] || '').trim();
    const phoneNumber = String(csvRow[phoneNumberIndex] || '').trim();
    const swapNumber = swapNumberIndex === -1 ? '' : String(csvRow[swapNumberIndex] || '').trim();

    if (clinicId && phoneNumber) {
      phoneNumbers[clinicId] = {
        phoneNumber,
        swapNumber
      };
    }

    return phoneNumbers;
  }, {});
};

export default function getMichiganClinicPhoneNumbers() {
  if (!phoneNumbersPromise) {
    phoneNumbersPromise = fetch(SHEET_CSV_URL)
      .then((response) => {
        const contentType = response.headers.get('content-type') || '';

        if (!response.ok || !contentType.includes('text/csv')) {
          // eslint-disable-next-line no-console
          console.warn('Beltone Michigan clinic phone sheet could not be loaded. Falling back to the default phone number.');
          return null;
        }
        return response.text();
      })
      .then((csv) => (csv ? buildPhoneNumberMap(csv) : {}))
      .catch(() => {
        // eslint-disable-next-line no-console
        console.warn('Beltone Michigan clinic phone sheet could not be loaded. Falling back to the default phone number.');
        return {};
      });
  }

  return phoneNumbersPromise;
}
